



























































import { PropType, defineComponent, computed, onMounted, ref } from '@vue/composition-api';
import { Message, MessageType, project, ProjectData } from '../../dataType';
import Card from './Card.vue';
import { useConfig, useAutomationConfig } from '../../hooks/useConfig';
import { useMessage } from '../../hooks/useMessage';
import { projectAssembleList } from '../../util/api';
import { useLocale } from '../../hooks/useLocale';

export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<ProjectData>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const projectList = ref<{
      id: number;
      pname: string;
    }[]>([]);
    const projectSelect = ref<number>();
    const { addMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const projects = computed<project[]>(() => {
      return (props.message.content.projects || []);
    });
    const messageType = computed<MessageType | undefined>(() => props.message.type);
    const { setAutomationProject } = useAutomationConfig();

    const sourceTitle = computed<string>(() => props.message.content.base.source);
    const title = computed<string | undefined>(() => {
      return messageType.value === 'ai.automation.ask.project'
        ? props.message.title
        : t('saas.robotChat.automation.selectProject');
    });

    onMounted(async () => {
      if (messageType.value === 'ai.chooseProjectList') {
        projectList.value = await projectAssembleList();
      }
    });

    const clickSendMessage = async (projectId: number | undefined) => {
      if (projectId === undefined) {
        return;
      }
      if (projectId === 0) {
        addMessage<ProjectData>({
          id: Date.now(),
          type: 'ai.chooseProjectList',
          userId: 0,
          avatar: props.message.avatar,
          content: props.message.content,
          title: props.message.title
        });
        return;
      }
      robotWaitWithAsyncOperation(async () => {
        await sendMessageAndUpdateId(null, 'input', props.message.content.base.source, undefined, {
          projectId: projectId
        });
        setAutomationProject(projectId);
      });
    };
    return {
      t,
      projects,
      clickSendMessage,
      messageType,
      projectSelect: projectSelect.value,
      title,
      sourceTitle,
      projectList
    };
  }
});
